export default "__VITE_ASSET__DsjGJ6Pi__"